import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { logoutAndRedirect } from '../../actions/auth';

export default Component => {
  const mapStateToProps = (state, ownProps) => ({
    isLoggedIn: state.auth.isLoggedIn,
    isAdmin: state.auth.isAdmin,
    isFederation: state.auth.isFederation,
    pathname: ownProps.location.pathname,
  });

  class IsVisitor extends Component {
    static propTypes = {
      dispatch: PropTypes.func.isRequired,
      isLoggedIn: PropTypes.bool.isRequired,
      isAdmin: PropTypes.bool.isRequired,
      isFederation: PropTypes.bool.isRequired,
      pathname: PropTypes.string.isRequired,
    };

    componentWillMount() {
      this.checkIsVisitor(this.props);
    }

    componentWillReceiveProps(nextProps) {
      this.checkIsVisitor(nextProps);
    }

    checkIsVisitor(props) {
      const { isLoggedIn, isAdmin, isFederation, dispatch } = props;

      if (isLoggedIn) {
        if (isAdmin) {
          dispatch(push('/admin'));
        } else if (isFederation) {
          dispatch(push('/federation'));
        } else {
          dispatch(logoutAndRedirect());
        }
      }
    }

    render() {
      const { isLoggedIn } = this.props;

      return <div>{!isLoggedIn && <Component {...this.props} />}</div>;
    }
  }

  return connect(mapStateToProps)(IsVisitor);
};



// WEBPACK FOOTER //
// ./src/containers/auth/IsVisitor.js